module.exports = __webpack_public_path__ + "img/rewards.d93517d9.svg";